<script>
    import Nav from '../components/Nav.svelte'
    import AllProducts from './product/allProducts.svelte'


   // Set tue shop closed alert 
  let showAlert = false

  function closeAlert() {
    showAlert = false
  }
</script>

<svelte:head>
    <title>Specker Bienchen Shop</title>
</svelte:head>

<!-- <Nav /> -->
{#if showAlert}
  <div
    id="alert-urlaub"
    class="p-4 mb-4 text-blue-800 border border-blue-300 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400 dark:border-blue-800"
    role="alert"
  >
    <div class="flex items-center">
      <svg
        class="shrink-0 w-4 h-4 me-2"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
        />
      </svg>
      <h3 class="text-lg font-medium">
        Shop geschlossen: 27.08. – 17.09.
      </h3>
    </div>
    <div class="mt-2 mb-2 text-sm">
      Unser Shop macht Sommerpause. In dieser Zeit sind keine Bestellungen möglich.
      Ab dem 18. August sind wir wieder für euch da.
    </div>
    <div class="flex">
      <button
        type="button"
        on:click={closeAlert}
        class="text-blue-800 bg-transparent border border-blue-800 hover:bg-blue-900 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-200 font-medium rounded-lg text-xs px-3 py-1.5 text-center dark:hover:bg-blue-600 dark:border-blue-600 dark:text-blue-400 dark:hover:text-white dark:focus:ring-blue-800"
        aria-label="Close"
      >
        Schließen
      </button>
    </div>
  </div>
{/if}

<div class="mb-[320px] max-w-[90%] mx-auto">
    <h1 class="mb-5 text-3xl font-semibold">Specker Bienen Shop</h1>
    <p>Kaufe Honig und Bienenwachsprodukte von Specker Bienen</p>

    <AllProducts />
</div>
